import { byRanking } from "./byRanking";
import { freezeMap } from "./freezeMap";

export function parseOdds(odds, betId, freeze = false) {
    return odds.map(odd => {
    	const parsedOdd = {
            id: odd.ce,
            desc: odd.ds,
            ranking: odd.rnk,
            value: null,
            tooltip: odd.tlt,
            tooltipByHandicap: odd.tlh,
            betId: betId,
            aliasListDefault: Object.freeze(odd.ald),
            aliasByHandicap: freezeMap(odd.alps),
            aliasBySystemCode: freezeMap(odd.alsys ? odd.alsys : null),
            aliasHandicapBySystemCode: freezeMap(odd.alsysp ? odd.alsysp : null)
        };
        if (freeze) {
            Object.freeze(parsedOdd);
        }
        return parsedOdd;
    }).sort(byRanking);
}
